import { render, staticRenderFns } from "./customers.vue?vue&type=template&id=38f20f58&scoped=true&"
import script from "./customers.vue?vue&type=script&lang=js&"
export * from "./customers.vue?vue&type=script&lang=js&"
import style0 from "./customers.vue?vue&type=style&index=0&id=38f20f58&lang=scss&scoped=true&"
import style1 from "./customers.vue?vue&type=style&index=1&id=38f20f58&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f20f58",
  null
  
)

/* custom blocks */
import block0 from "./customers.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports